import React from 'react';
import PropTypes from 'prop-types';
import { StyledCard } from './style';

const CardHomeBox = ({
	icon,
	altIcon,
	titleIcon,
	title,
	titleRed,
	text,
	classComponent,
}) => (
	<StyledCard className={classComponent}>
		<div className="content-header">
			<img src={icon} alt={altIcon} title={titleIcon} className="icon" />
		</div>
		<div>
			<h4>{title}</h4>
			<br />
			<span>{titleRed}</span>
		</div>
		<div className="content-body">{text}</div>
	</StyledCard>
);

PropTypes.Card = {
	icon: PropTypes.element,
	altIcon: PropTypes.string,
	titleIcon: PropTypes.string,
	title: PropTypes.string.isRequired,
	text: PropTypes.string.isRequired,
	classComponent: PropTypes.string,
};

export default CardHomeBox;
